/**
 * pricePolicy.js — THE single source of truth for every published price on
 * Route Facile. Owner-approved wording (2026-10-29, amended 2026-10-30).
 * No other price may appear in content: no per-model prices, no discounts,
 * no offers. No minimum or maximum rental duration may be stated.
 */
const PRICE_POLICY = {
  en: "from 250 MAD (25 €) to 1,200 MAD (120 €) per day, depending on the vehicle category",
  fr: "de 250 MAD (25 €) à 1 200 MAD (120 €) par jour, selon la catégorie du véhicule",
  ar: "من 250 درهم (25 يورو) إلى 1,200 درهم (120 يورو) لليوم، حسب الفئة والمدة",
  // JSON-LD priceRange on both office entities.
  priceRangeJsonLd: "25 €–120 €",
};

export default PRICE_POLICY;